import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
    return (
        <div>
            <Header />
            <div className="max-w-2xl mx-auto px-6 py-20 text-center">
                <div className="mx-auto w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mb-6">
                    <XCircle size={32} className="text-red-500" />
                </div>
                <h1 className="font-display text-4xl mb-3">Paiement annulé</h1>
                <p className="text-slate-500 mb-8">
                    Aucun montant n'a été prélevé. Vous pouvez retenter à tout moment.
                </p>
                <Link to="/devis" className="btn-gold inline-block" data-testid="cancel-back-btn">
                    Retour au devis
                </Link>
            </div>
            <Footer />
        </div>
    );
}
